export default "__VITE_ASSET__CDnTA5re__"